
import GameiomGameOver from "gameiom/states/gameiom-game-over";
import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";

export default class GameiomGameOverFreespins extends GameiomGameOver {
    public complete() {
        const win = GameState.getCurrentGame().getTotalWin();
        gameWrapper.winningsUpdate(win);

        super.complete();

        Components.footer.showFreespinStart();
    }
}
